<template>
     <b-row class="p-4">
        <b-col cols="12" md="8" v-if="getWebTheme">
            <template v-if="!hasResults">
                <b-row class="pb-4">
                    <b-col SMT-NG-ACCESSIBLE_DESCRIPTION>
                        {{getWebTheme.data.description}}
                    </b-col>
                </b-row>
                <b-row class="pb-4">
                    <b-col>
                        <b-link
                            @focus="onFocus(`${xi18n(i8nPrefix, 'noResultsSearch')}, ${xi18n(i8nPrefix, 'noResultsClickOnMap')}`)"
                            :to="{name: 'accessibleSearch'}">{{xi18n(i8nPrefix, 'noResultsSearch')}}
                        </b-link>
                        {{xi18n(i8nPrefix, 'noResultsClickOnMap')}}
                    </b-col>
                </b-row>
            </template>
            <template v-else>
                <b-row class="pb-4">
                    <b-col  class="d-flex flex-column">
                        {{xi18n(i8nPrefix, 'displayResults', [getSelectionObjectsCount, $store.getters.getSelectionObjectsSelectedGroup.title])}}
                    </b-col>
                </b-row>
                <group-buttons />
                <item-pager mode="group" />
            </template>
        </b-col>
        <b-col cols="12" md="4">
            <data-display v-if="currentMapFocus" :displayData="currentMapFocus" i8nPrefix="accessibility" />
        </b-col>
    </b-row>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex';
    import GroupButtons from '../../information/selection/GroupButtons.vue';
    import ItemPager from '../../information/selection/ItemPager.vue';
    import DataDisplay from '../../../BaseComponents/DataDisplay.vue';

    export default {
        components: {
            'group-buttons': GroupButtons,
            'item-pager': ItemPager,
            'data-display': DataDisplay,
        },
        data() {
            return {
                currentMapFocus: null,
                i8nPrefix: 'accessibility'
            };
        },
        computed: {
            ...mapState(['pointer']),
            ...mapGetters(['getSelectionObjectsCount', 'getSelectionObjectsSelectedGroup', 'getWebTheme']),
            hasResults() {
                return this.getSelectionObjectsCount > 0;
            },
            point() {
                if (!this.pointer) {
                    return null;
                }
                return { point: this.pointer?.location?.point };
            }
        },
        methods: {
            ...mapActions(['getAddressInfo']),

            onFocus(text) {
                this.$store.dispatch('say', { text });
            }
        },
        watch: {
            'pointer.location.point': {
                handler: async function(newVal) {
                    if (!newVal) {
                        return;
                    }
                    const addressInfo = await this.getAddressInfo(newVal);
                    // Check if real address was found
                    if (addressInfo && addressInfo.data && addressInfo.data.streetName) {
                        if (this.$store.state.accessibility?.newSearch) {
                            this.currentMapFocus = null;
                            this.$store.state.accessibility.newSearch = false;
                            // clear pointer
                            this.$store.commit('SET_POINTER', { location: null });
                        } else {
                            const text = addressInfo.data.displayName;
                            this.currentMapFocus = { address: text };
                            this.$store.dispatch('say', { text });
                        }
                    }
                },
                immediate: true
            }
        }
    };
</script>
